import { AutogenModelMiscBillDetail, AutogenRowMiscBillDetail } from "./autogen/AutogenModelMiscBillDetail";

export class ModelMiscBillDetail extends AutogenModelMiscBillDetail<RowMiscBillDetail> {
	constructor() {
		super(RowMiscBillDetail);
	}
}

export class RowMiscBillDetail extends AutogenRowMiscBillDetail {
}